<template>
  <v-menu
    v-model="showCart"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text color="primary" v-on="on" v-bind="attrs">
        <v-icon left>mdi-folder-star</v-icon>
        ({{ getFavorites.length }})
      </v-btn>
    </template>
    <v-card elevation="18" class="favorites" color="primary">
      <v-list>
        <v-list-item class="b-b">
          <v-list-item-content>
            <v-list-item-title>JOB CART</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn small right text color="primary" @click="clearFavorites()"
              >Clear</v-btn
            >
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          v-for="job in getFavorites"
          :key="job.id"
          :id="job.id"
          class="job"
        >
          <v-list-item-content>
            <v-list-item-title>{{ job.title }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ job.employer.name }},
              {{ job.location.city }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="primary" @click="removeFavorite(job)"
              >mdi-delete</v-icon
            >
          </v-list-item-action>
          <v-list-item-action>
            <v-icon color="primary" @click="openUrl(job.externalUrl)"
              >mdi-open-in-new</v-icon
            >
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-if="getFavorites.length == 0">
          You haven't added any favorites yet.
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'JobCart',
  props: {
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    removeFavorite(job) {
      this.$store.dispatch('commitFavorite', {
        jobId: job.id,
        action: 'remove',
      });
      return null;
    },
    clearFavorites() {
      this.$store.dispatch('commitFavorite', { action: 'clear' });
    },
  },
  computed: {
    getFavorites() {
      return this.$store.state.userFavorites;
    },
    showCart: {
      get() {
        return this.$store.state.userFavorites.length === 1;
      },
      set(value) {
        return value;
      },
    },
  },
};
</script>
<style scoped>
</style>
